const reactDropzoneSkin = {
  dropzone: {
    padding: "7px 15px",
    border: "2px dashed var(--gc-border-separator-color)",
    cursor: "pointer",
    marginBottom: "10px",
  },
  "dropzone-container": {
    marginBottom: "10px",
  },
  "file-list-row": {
    padding: "5px 0",
  },
};

export default reactDropzoneSkin;
